<mat-toolbar color="primary" class="app-header">
  <div class="header-side header-side--left">
    @if (showBack()) {
      <a mat-icon-button routerLink="/" aria-label="Zurück zum Dashboard">
        <mat-icon>arrow_back</mat-icon>
      </a>
    }
    @if (sectionTitle()) {
      <span class="section-title">{{ sectionTitle() }}</span>
    }
  </div>

  <a class="logo-link" routerLink="/" aria-label="Fraternity Wars – Startseite">
    <img class="logo" src="/fw_logo.png" alt="Fraternity Wars" />
  </a>

  <div class="header-side header-side--right">
    @if (auth.user(); as user) {
      <span class="username">{{ user.username }}</span>
      <button
        mat-button
        class="coin-balance"
        [class.coin-balance--admin]="auth.isAdmin()"
        (click)="editBalance()"
        [matTooltip]="auth.isAdmin() ? 'Coins setzen' : ''"
      >
        <mat-icon inline>monetization_on</mat-icon>
        {{ user.coinBalance }}
      </button>
      @if (auth.isAdmin()) {
        <a mat-icon-button routerLink="/admin" matTooltip="Admin-Bereich" aria-label="Admin-Bereich">
          <mat-icon>admin_panel_settings</mat-icon>
        </a>
      }
      <button mat-icon-button (click)="logout()" aria-label="Logout" matTooltip="Logout">
        <mat-icon>logout</mat-icon>
      </button>
    }
  </div>
</mat-toolbar>
